const commonUI = {

  confirmWarning: function (title, message, callBackConfirm, callBackCancel) {
    this.$confirm(message, title, {
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      closeOnPressEscape: false,
      closeOnClickModal: false,
      type: 'warning'
    }).then(() => {
      callBackConfirm()
    }).catch(() => {
      callBackCancel()
    })
  }

}
export default commonUI
